<br />
<br />
<br />
<br />
<br />
<br />
<div class="text-center">
  <img src="../../../assets/img/coming-soon.png" />

  <h3>{{ "This Service is Coming Soon" | translate }}</h3>

  <button class="gradient-button" routerLink="">
    {{ "Go Back To Home Page" | translate }}
  </button>
</div>
